import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { amendmentChanges } from '@app/features/amendments/amendment-changes';
import { Amendment } from '@app/features/amendments/amendment.model';
import moment from 'moment';

/**
 * La vue des modifications d'un avenant, ouverte par défaut (RG-avenant-consultation) : sa date
 * d'effet, sa durée et ses motifs, puis seulement ce qu'il change, avant et après, par thème.
 */
@Component({
  selector: 'app-amendment-changes-view',
  templateUrl: './amendment-changes-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./amendment-changes-view.scss'],
})
export class AmendmentChangesView {
  readonly amendment = input.required<Amendment>();

  readonly changes = computed(() => amendmentChanges(this.amendment()));

  readonly effectiveDate = computed(() =>
    moment(this.amendment().effectiveDate).format('DD/MM/YYYY'),
  );

  readonly duration = computed(() => {
    const endDate = this.amendment().endDate;
    return endDate
      ? `Temporaire, jusqu'au ${moment(endDate).format('DD/MM/YYYY')}`
      : 'À durée indéterminée';
  });
}
